export default __webpack_public_path__ + "static/media/logo.e848cc92.svg";